import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=f90b56be&scoped=true&lang=pug&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90b56be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f90b56be')) {
      api.createRecord('f90b56be', component.options)
    } else {
      api.reload('f90b56be', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=f90b56be&scoped=true&lang=pug&", function () {
      api.rerender('f90b56be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/VButton.vue"
export default component.exports